import React from 'react';

import { AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

import { useBreakpoints } from '@pkg/hooks';

import { Icon, type IconsType } from '../Icon';
import { Count } from '../NavButton/styles';
import { Emoji } from '../styles';

import { ActionButtonHolder, Chevron, Text, TextWrapper, Wrapper } from './styles';

interface ToggleProps {
    children: React.ReactNode;
    icon?: IconsType;
    emoji?: string;
    count?: string | number;
    isChild?: boolean;
    showWhenOpen?: React.ReactNode;
    showWhenClosed?: React.ReactNode;
    showAlways?: React.ReactNode;
    isOpen: boolean;
    setIsOpen?: (isOpen: boolean) => void;
    noTransition?: boolean;
    setNoTransition?: (noTransition: boolean) => void;
    isStatic?: boolean;
    titleLink?: string;
}

export const Toggle = ({
    children,
    icon,
    emoji,
    count,
    isChild,
    showWhenOpen,
    showWhenClosed,
    showAlways,
    isOpen,
    setIsOpen,
    setNoTransition,
    isStatic,
    titleLink,
}: ToggleProps) => {
    const { isMobile } = useBreakpoints();

    const handleToggle = () => {
        if (setIsOpen) setIsOpen(!isOpen);
        if (setNoTransition) setNoTransition(false);
    };

    const linkProps: Record<string, unknown> = titleLink && isStatic && !isMobile ? { as: Link, to: titleLink } : {};

    return (
        <Wrapper onClick={handleToggle} $isChild={isChild} $isOpen={isOpen} $isStatic={isStatic || !setIsOpen}>
            <TextWrapper {...linkProps}>
                {icon && <Icon name={icon} />}
                {emoji && !icon && <Emoji emojiID={emoji} $isOpen={isOpen} aria-hidden />}

                <Text title={children?.toString()}>
                    {children} {Boolean(count) && <Count aria-hidden>{count}</Count>}
                </Text>
            </TextWrapper>

            <AnimatePresence>
                {showWhenOpen && isOpen && (
                    <ActionButtonHolder
                        initial={false}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        key="show-when-open"
                    >
                        {showWhenOpen}
                    </ActionButtonHolder>
                )}

                {showWhenClosed && !isOpen && (
                    <ActionButtonHolder
                        initial={false}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 10 }}
                        key="show-when-closed"
                    >
                        {showWhenClosed}
                    </ActionButtonHolder>
                )}

                {showAlways && <ActionButtonHolder key="show-always">{showAlways}</ActionButtonHolder>}
            </AnimatePresence>

            {!isStatic && setIsOpen && <Chevron $direction={isOpen ? 'down' : 'up'} aria-hidden />}
        </Wrapper>
    );
};
